function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "480px",
    height: "480px",
    viewBox: "0 0 480 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(12.941176%,58.823529%,95.294118%)",
      fillOpacity: 1
    },
    d: "M 30 0 L 68.25 432 L 240 480 L 411.691406 432.03125 L 450 0 Z M 30 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.039216%,98.039216%,98.039216%)",
      fillOpacity: 1
    },
    d: "M 368.21875 141.269531 L 363.390625 195.539062 L 348.808594 358.230469 L 240 388.320312 L 239.910156 388.351562 L 131.160156 358.230469 L 123.570312 273.148438 L 176.851562 273.148438 L 180.808594 317.28125 L 239.941406 333.238281 L 239.96875 333.210938 L 299.191406 317.25 L 307.261719 243.71875 L 121.019531 244.230469 L 115.738281 193.949219 L 311.730469 191.640625 L 315.691406 137.820312 L 110.488281 138.390625 L 107.039062 88.320312 L 372.960938 88.320312 Z M 368.21875 141.269531 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.dce23c200436d0d15b80f5a4c47aeefb.svg";
export { ForwardRef as ReactComponent };